import { MOVE_ROW_BENEFICIARY_STATUS } from '@/modules/move/entities/enums/move';

export const countStatusDefault = {
  [MOVE_ROW_BENEFICIARY_STATUS.PROCESSED]: 0,
  [MOVE_ROW_BENEFICIARY_STATUS.NOT_INITIALIZED]: 0,
  [MOVE_ROW_BENEFICIARY_STATUS.VALIDATED_WITH_ERROR]: 0,
  [MOVE_ROW_BENEFICIARY_STATUS.VALIDATED]: 0,
  [MOVE_ROW_BENEFICIARY_STATUS.PROCESSED_WITH_ERROR]: 0,
  [MOVE_ROW_BENEFICIARY_STATUS.UNKNOWN]: 0,
};
